"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetField = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _AssetSelector = _interopRequireDefault(require("../AssetSelector/AssetSelector"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _AssetCard = _interopRequireDefault(require("../AssetCard/AssetCard"));

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _InputLabel = _interopRequireDefault(require("@civicplus/preamble/lib/InputLabel"));

var _FormControl = _interopRequireDefault(require("@civicplus/preamble/lib/FormControl"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Alert = require("../Utility/Alert");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("@civicplus/preamble/lib/ErrorHandlingFormHelperText"));

var _core = require("@material-ui/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AssetField = function AssetField(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      linked = _useState4[0],
      setLinked = _useState4[1];

  var onAssetsLinked = function onAssetsLinked(assets) {
    closeAssetSelector();
    props.onChange({
      target: {
        value: assets.map(function (w) {
          if (w.id) {
            return w.id;
          } else {
            throw new Error("Asset is missing ID");
          }
        })
      }
    });
  };

  var closeAssetSelector = function closeAssetSelector() {
    setOpen(false);
  };

  var removeLinkedAsset = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(asset) {
      var excluded;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!props.value) {
                _context.next = 5;
                break;
              }

              excluded = props.value.filter(function (w) {
                return asset.id !== w;
              });
              props.onChange({
                target: {
                  value: excluded
                }
              });
              _context.next = 6;
              break;

            case 5:
              throw new Error("AssetField is missing value prop");

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function removeLinkedAsset(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var load = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var api, assets;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(props.value == null || props.value.length === 0)) {
                  _context2.next = 3;
                  break;
                }

                setLinked([]);
                return _context2.abrupt("return");

              case 3:
                api = new _sdk.AssetsApi(props.config);
                _context2.next = 6;
                return api.getAssets(props.config.appName, undefined, undefined, undefined, undefined, undefined, undefined, props.value.join(","));

              case 6:
                assets = _context2.sent;
                setLinked(assets.items);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    (0, _Alert.alertOnError)("Failed to load linked assets.", load); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      errorMessage = props.errorMessage,
      helperText = props.helperText,
      id = props.id,
      label = props.label,
      required = props.required;
  var rootLabelProps = {
    id: id,
    disabled: disabled,
    shrink: false
  };
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    id: id,
    className: (0, _classnames["default"])("prmbl-assetField", className),
    error: error,
    disabled: disabled,
    required: required,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])("prmbl-assetField-label", classes.assetLabel)
  }, rootLabelProps), label), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.assetBoxWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.assetDiv
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: props.disabled,
    onClick: function onClick() {
      return setOpen(true);
    }
  }, "Select File(s)"), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("prmbl-assetField-grid", classes.selectedAssets),
    id: "".concat(id, "-selected-container")
  }, linked.map(function (a, index) {
    var buttonProps = disabled ? undefined : {
      color: "secondary",
      display: "Remove",
      onClick: function onClick(event) {
        return removeLinkedAsset(a);
      },
      variant: "text"
    };
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      key: a.id ? a.id + index : index
    }, /*#__PURE__*/_react["default"].createElement(_AssetCard["default"], {
      asset: a,
      config: props.config,
      bottomButtonProps: buttonProps
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_AssetSelector["default"], {
    id: "asset-selector",
    value: linked,
    config: _objectSpread({}, props.config),
    onAssetsLinked: onAssetsLinked,
    showFilter: true,
    ShowAsDialog: true,
    openDialog: open,
    onCloseDialog: closeAssetSelector,
    onCancel: closeAssetSelector
  }), /*#__PURE__*/_react["default"].createElement(_ErrorHandlingFormHelperText["default"], {
    id: "error-handler-text-" + id,
    helperText: helperText,
    error: error,
    errorMessage: errorMessage
  }), /*#__PURE__*/_react["default"].createElement(_ErrorHandlingFormHelperText["default"], {
    id: id,
    error: error,
    helperText: helperText,
    errorMessage: errorMessage
  }));
};

exports.AssetField = AssetField;

var _default = (0, _core.withStyles)(_styles.styles)(AssetField);

exports["default"] = _default;